<template>
<div>
  <div class="foot" @click="btn">
    <div class="footText">打开“嗨科普”看评论</div>
    <div class="footComment"><span v-if="commentNum!=0" class="tipNum">{{ commentNum }}</span></div>
    <div class="footCollect"><span v-if="collectionNum!=0" class="tipNum">{{ collectionNum }}</span></div>
    <div class="footGiveGood"><span v-if="goodNum!=0" class="tipNum">{{ goodNum }}</span></div>
  </div>
</div>
</template>

<script>
export default {
  name: "foot",
  props:{
    commentNum:{
      type: Number
    },
    collectionNum:{
      type: Number
    },
    goodNum:{
      type: Number
    }
  },
  methods:{
    btn(){
      console.log('foot open app')
      this.$emit("openApp",null)
    }
  }
}
</script>

<style scoped>
.foot{
  border-top: 1px solid #f3f3f3;
  position: fixed;
  bottom: 0px;
  height: 130px;
  width: 100%;
  background-color: white;
  z-index: 10;
}
.footText{
  margin-top: 25px;
  margin-right: 60px;
  float: left;
  margin-left: 45px;
  font-size: 40px;
  height: 80px;
  line-height: 80px;
  background-color: #dadada;
  border-radius: 12px;
  padding-left: 40px;
  padding-right: 40px;
  letter-spacing: 0.1em;
}
.footComment,
.footGiveGood,
.footCollect
{
  float: left;
  margin-right: 100px;
  width: 60px;
  height: 100%;
  /*background-color: #790e0e;*/
  background-repeat: no-repeat;
  background-position: center center;
}
.footComment{
  background-image: url("../../assets/app/comment.png");
  background-size: 57px 45px;
}
.footGiveGood{
  background-image: url("../../assets/app/giveGood.png");
  background-size: 50px 49px;
}
.footCollect{
  background-image: url("../../assets/app/collect.png");
  background-size: 50px 49px;
}
.tipNum{
  position: relative;
  left: 25px;
  top: 10px;
  background-color: #ee0a24;
  font-size: 25px;
  height: 30px;
  min-width: 100px;
  line-height: 30px;
  text-align: center;
  color: white;
  border-radius: 15px;
  padding-right: 13px;
  padding-left: 13px;
  padding-top: 1px;
  padding-bottom: 1px;
}

</style>